var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-progress-bar',{staticClass:"loading",attrs:{"md-mode":"indeterminate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }